// src/components/home/HeroSection.tsx
import React from "react";

const HeroSection: React.FC = () => {
  return (
    <section className="hero-wrapper">
      {/* Overlay (background image handled via CSS) */}
      <div className="home-hero-overlay hero-overlay" />

      <div className="hero-content">
        {/* Badge */}
        <div className="hero-badge">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
          >
            <path
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9"
            ></path>
          </svg>
          <span>Cloud-Native Architect & Generative AI Specialist</span>
        </div>

        {/* Name */}
        <h1 className="home-hero-title hero-title">Anuj Kumar Tiwari</h1>

        {/* Outcome-focused subtitle */}
        <p className="home-hero-subtitle hero-subtitle">
          Delivering robust, secure, and scalable cloud platforms on AWS.
          Expertise in Java, Node.js, React, and Generative AI to build reliable
          enterprise systems.
        </p>

        {/* Skill pillars */}
        <div className="hero-skills">
          <div className="hero-skill-item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9"
              ></path>
            </svg>
            <span>Cloud Architecture · AWS · EKS · Microservices</span>
          </div>

          <div className="hero-skill-item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <g
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              >
                <path d="M12 18V5m3 8a4.17 4.17 0 0 1-3-4a4.17 4.17 0 0 1-3 4m8.598-6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"></path>
                <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"></path>
                <path d="M18 18a4 4 0 0 0 2-7.464"></path>
                <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"></path>
                <path d="M6 18a4 4 0 0 1-2-7.464"></path>
                <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"></path>
              </g>
            </svg>
            <span>Generative AI · RAG · LLM Apps · MLOps</span>
          </div>

          <div className="hero-skill-item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
              ></path>
            </svg>
            <span>
              Full-Stack Engineering · Java & Spring · React · Node.js
            </span>
          </div>
        </div>

        {/* Primary calls-to-action */}
        <div className="hero-actions">
          <a
            href="/resume/Anuj_Tiwari.pdf"
            className="btn btn-primary"
            target="_blank"
            rel="noreferrer"
          >
            View Architect Resume (PDF)
          </a>
          <a href="#projects" className="btn btn-secondary">
            View Architecture Portfolio
          </a>
        </div>

        {/* Credibility strip */}
        <div className="hero-location">
          <span>
            18+ Years Exp in Full Stack Development • AWS Certified Solutions
            Architect Professional • EdTech, Retail, Financial Services,
            Telecom, BioInformatics
          </span>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
